<template>
    <el-tag class="styled-tag" :class="class" :style="tagStyle">
        <span class="text">{{ text }}</span>
        <el-icon v-if="close" @click="$emit('close')">
            <svg
                class="trash-icon"
                enable-background="new 0 0 12.3 18"
                version="1.1"
                viewBox="0 0 12.3 18"
                xml:space="preserve"
                xmlns="http://www.w3.org/2000/svg"
            >
                <g class="bin">
                    <path
                        class="st0"
                        d="m11.8 4.4h-11.3c-0.3 0-0.5 0.2-0.5 0.5v0.1l1.2 12.1c0 0.5 0.5 1 1 1h7.8c0.5 0 1-0.4 1-1l1.2-12.1c0.1-0.3-0.1-0.6-0.4-0.6zm-8.2 11.8c-0.3 0-0.5-0.2-0.5-0.4l-0.8-9.1c0-0.3 0.2-0.5 0.4-0.5 0.3 0 0.5 0.2 0.5 0.4l0.8 9.1c0 0.3-0.1 0.5-0.4 0.5zm3-0.4c0 0.3-0.2 0.5-0.5 0.5s-0.5-0.2-0.5-0.5v-9.2c0-0.3 0.2-0.5 0.5-0.5s0.5 0.2 0.5 0.5v9.2zm2.7 0c0 0.3-0.2 0.5-0.5 0.4-0.3 0-0.4-0.3-0.4-0.5l0.6-9.1c0-0.3 0.2-0.5 0.5-0.4 0.3 0 0.4 0.3 0.4 0.5l-0.6 9.1z"
                    />
                </g>
                <g class="lid">
                    <path
                        class="st0"
                        d="m10.7 1.1h-3.4c0-0.6-0.5-1.1-1.1-1.1-0.7 0-1.1 0.5-1.1 1.1h-3.5c-0.9 0-1.6 0.7-1.6 1.6v0.2c0 0.2 0.2 0.5 0.4 0.5h11.4c0.2 0 0.5-0.2 0.5-0.5v-0.2c0-0.9-0.7-1.6-1.6-1.6z"
                    />
                </g>
            </svg>
        </el-icon>
        <!-- <div class="separator"></div>
      <button class="ai-button">
        <img src="/media/images/web_search/ai_icon.svg" alt="AI Icon" class="ai-icon" @click="onAiIconClick" />
      </button> -->
    </el-tag>
</template>

<script>
export default {
    props: {
        mainFilters: {
            type: Array,
            required: false,
        },
        text: {
            required: true,
        },
        close: {
            required: false,
            default: false,
        },
        hover: {
            required: false,
            default: false,
        },
        size: {
            required: false,
            default: false,
        },
        tagId: {
            required: false,
            default: false,
        },
    },
    computed: {
        class() {
            return {
                hover: this.hover === true,
                small: this.size === "small",
            };
        },
        tagStyle() {
            if (this.mainFilters) {
                const filter = this.mainFilters.find(
                    (f) => f.id === this.tagId,
                );
                return filter
                    ? { backgroundColor: filter.color, color: "#fff" }
                    : {};
            }

            return "";
        },
    },
    methods: {
        async onAiIconClick() {
            if (this.mainFilters.length >= 10) {
                this.$emit("maxCompetencesLimitReached");
                return;
            }

            this.$functions.showLoader();

            try {
                let question = "Find similar skills to " + this.text;
                await api.apiClient.get("/sanctum/csrf-cookie");
                const response = await api.apiClient.post(
                    "api/ai/response",
                    {
                        thread_id: null,
                        run_id: null,
                        question: question,
                    },
                    { withCredentials: true },
                );

                let skillIds = response.data.skill_ids || [];
                if (!skillIds.includes(this.tagId)) {
                    skillIds.push(this.tagId);
                }

                const currentActiveIds = this.mainFilters.map((f) => f.id);
                const newSkillsToFetch = skillIds.filter(
                    (id) => !currentActiveIds.includes(id),
                );

                const remainingSlots = 10 - this.mainFilters.length;
                const finalSkillIds = [
                    ...currentActiveIds,
                    ...newSkillsToFetch.slice(0, remainingSlots),
                ];

                this.$emit("newSearch", {
                    competence: finalSkillIds,
                    modifier: "AI",
                });
            } catch (error) {
                console.error(error);
            } finally {
                this.$functions.hideLoader();
            }
        },
    },
};
</script>

<style scoped>
.styled-tag {
    color: #3c3c3c;
    background-color: #fff;
    padding-left: 10px;
    padding-right: 10px;
    height: 32px;
    font-size: 18px;
    font-weight: 400;
    border-color: #bcbab6;
    max-width: 100%;
    display: flex;
    align-items: center;
}

.styled-tag:not(.small) {
    border: unset;
    height: 37px;
}

.styled-tag.hover:hover {
    color: #2699b2;
    cursor: pointer;
}

.styled-tag.small {
    height: 24px;
    font-size: 16px;
    border-color: #2699b2;
}

.styled-tag.small .separator {
    display: none;
}

.styled-tag .text {
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    line-height: 30px;
}

.styled-tag :deep(.el-tag__content) {
    align-items: center;
    display: flex;
    max-width: 100%;
}

.styled-tag :deep(.el-icon),
.styled-tag :deep(.el-icon svg) {
    width: 22px;
    height: 20px;
}

.styled-tag.small :deep(.el-icon),
.styled-tag.small :deep(.el-icon svg) {
    width: 18px;
    height: 18px;
}

.styled-tag .el-icon {
    padding-left: 25px;
}

.separator {
    width: 0px;
    background-color: #fff;
    border-left: 1px solid #fff;
    height: 24px;
    margin: 0 10px;
    margin-left: 1px;
    margin-right: 5px;
}

.ai-icon {
    width: 20px;
    height: 20px;
    cursor: pointer;
}

.ai-button {
    padding: 0 !important;
    border-radius: 5px;
    width: 25px;
    background-color: #fff;
}

.ai-button:hover {
    background: linear-gradient(
        90deg,
        #a06dd6,
        #9e6ed6,
        #8f7ad1,
        #8682cf,
        #8385ce,
        #7e89cd,
        #7a8dcc,
        #7690ca,
        #7294c9,
        #6d9ac7,
        #6d9ac7,
        #699fc6,
        #68a0c6,
        #67a2c5
    );
    border: unset;
}

.ai-button:hover img {
    filter: brightness(0) saturate(100%) invert(100%) sepia(100%) saturate(0%)
        hue-rotate(288deg) brightness(102%) contrast(102%);
}

.styled-tag.small .ai-button {
    display: none;
}

.styled-tag.small .ai-icon {
    display: none;
}

.trash-icon {
    width: 16px;
    height: 16px;
    cursor: pointer;
    filter: brightness(0) saturate(100%) invert(100%) sepia(100%) saturate(0%)
        hue-rotate(288deg) brightness(102%) contrast(102%);
}

.trash-icon:hover {
    filter: brightness(0) saturate(100%) invert(100%) sepia(100%) saturate(0%)
        hue-rotate(288deg) brightness(102%) contrast(102%);
}

.styled-tag.small .trash-icon {
    width: 16px;
    height: 16px;
}

.trash-icon .lid {
    transition: transform 0.2s ease-in-out;
}

.trash-icon:hover .lid {
    transform: translateY(-0.7px);
}

@media (max-width: 768px) {
    .styled-tag {
        max-width: unset !important;
    }
}
</style>
